import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSigninComplete } from './AuthProps';
export var AuthGuard = function AuthGuard(_ref) {
  var children = _ref.children,
    extraSigninRequestArgs = _ref.extraSigninRequestArgs;
  var _useAuth = useAuth(),
    isAuthenticated = _useAuth.isAuthenticated,
    isLoading = _useAuth.isLoading,
    error = _useAuth.error,
    activeNavigator = _useAuth.activeNavigator;
  var signinComplete = useSigninComplete();
  useEffect(function () {
    var isSigningOut = activeNavigator === 'signoutRedirect';

    // if user is not authenticated, try signing in
    if (isSigningOut || isAuthenticated || isLoading) {
      return;
    }

    // sign in silent or with redirect, depending on valid session
    signinComplete(extraSigninRequestArgs);

    // error added as a dependency to force retry
  }, [error, isLoading, isAuthenticated, activeNavigator, signinComplete, extraSigninRequestArgs]);
  if (isAuthenticated) {
    // wrap in fragment to cast to JSX.Element
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  // TODO: add loader
  return null;
};